import { jsx as _jsx } from "react/jsx-runtime";
import { PastPerformanceTab } from '../../PastPerformance/PastPerformanceTab';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/** Past performance (Working papers), moved from its tab. */ export function PastPerformanceSection() {
    const { captureProjectId } = usePursuitRecord();
    // GRW-30: sections always sit in the record shell, so the gate is the header capabilities.
    const { canEdit } = usePursuitRecord().capabilities;
    return /*#__PURE__*/ _jsx(PursuitSectionFrame, {
        title: "Past performance",
        children: /*#__PURE__*/ _jsx(PastPerformanceTab, {
            readOnly: !canEdit,
            captureProjectId: captureProjectId
        })
    });
}
